module.exports = __webpack_public_path__ + "media/png/job-offer@3x-73c373d1.png";